<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'game_list'}" class="float-left mr-1 main-link">{{$t('game.game')}}</router-link> / {{$t('game.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('coupon.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :name="`name[${lang}]`" />
                    </div>
                  </div>

                  <div class="form-group row hide">
                    <legend class="col-sm-2 col-form-label">{{$t('game.url')}}</legend>
                    <div class="col-sm-10">
                      <b-form-input
                        v-model="item.url"
                        v-bind:placeholder="$t('game.url')"/>
                    </div>
                  </div>


                  <div class="form-group row margin-top20">
                    <legend class="col-sm-2 col-form-label">
                      {{ $t('coupon.description') }}
                    </legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-textarea class="form-control" v-model="item.description[lang]"
                      :rows="5" :max-rows="10" v-bind:placeholder="$t('common.text_'+lang)">
                      </b-form-textarea>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="coupon-image col-sm-6" v-for="(data, image) in imageData" :key="data.id">
                      <legend class="col-sm-4 col-form-label">
                        {{ $t('coupon.image_'+image) }}
                        <!-- <i class="fa fa-info-circle text-primary" :id="'image-' + image"></i> -->
                        <b-tooltip :target="'image-' + image" placement="top">
                          <div class="text-left" v-html="getImageHelpInfo('coupon', image)"></div>
                        </b-tooltip>
                      </legend>
                      <div class="col-sm-8">
                        <b-form-file :id="image" @change="previewImage" accept="image/*"
                        :placeholder="$t('message.choose_a_file')"></b-form-file>

                        <div v-bind:class="'image-' + image + '-preview img-min-height'">
                          <img class="previewImage" v-bind:src="data">
                        </div>
                      </div>
                    </div>
                  </div>

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <!-- Time settings -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('game.game_settings') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateGameSettingStatus"  v-b-toggle.time_settings_content>
                <i class="fa fa-sort-down" v-if="gameSettingStatus"></i>
                <i class="fa fa-sort-up" v-if="!gameSettingStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="gameSettingStatus" id="time_settings_content">
              <b-form class="row">
                <b-col cols="12">

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('game.game_settings')}}</legend>
                    <div class="col-sm-10">
                      <a class="add-more" v-on:click="addGameSetting()"><i class="fa fa-plus"></i>{{$t('game.add_more')}}</a>

                      <table class="table table-bordered table-hover">
                        <thead>
                        <tr>
                          <th width="15%">{{isNZ() ? $t('coupon.tier') : $t('game.coupon_value')}}</th>
                          <th width="30%">{{isNZ() ? $t('coupon.name') : $t('game.coupon_code')}}</th>
                          <th v-for="(time, key) in item.time_play" :key='key'>{{timeForGame(key+1)}}</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(setting, index) in item.game_settings" :key="setting.id">
                          <td>
                            <multiselect
                              v-if="isNZ()"
                              v-model="setting.coupon_value"
                              :options="couponValueList"
                              :multiple="false"
                              :close-on-select="true"
                              track-by="text"
                              label="text"
                              v-bind:placeholder="$t('common.name')"
                              v-bind:selectLabel="''"
                              v-bind:deselectLabel="''"
                              v-bind:selectedLabel="''"
                              :disabled="setting.coupon_value.value === '0'"
                              >
                            </multiselect>
                            <b-form-input v-else type="number" class="form-control" v-model="item.game_settings[index].coupon_value"></b-form-input>
                          </td>
                          <td>
                            <multiselect
                             v-model="setting.coupon_code"
                             :options="couponList"
                             :multiple="false"
                             :close-on-select="true"
                             track-by="text"
                             label="text"
                             v-bind:placeholder="$t('common.name')"
                             @input="isNZ() ? couponCodeChange(index, setting.coupon_code) : ''"
                             >
                          </multiselect>
                          </td>
                          <td v-for="(time, key) in item.time_play" :key='key'>
                            <b-form-input type="number" class="form-control" v-model="item.game_settings[index].time_play[key]"></b-form-input>
                          </td>
                          <td class="center">
                            <b-button variant="danger" v-on:click="removeGameSetting(index)"
                            size="sm"><i class="fa fa-trash-o"></i></b-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Time settings -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'game_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="$v.item.$invalid" variant="success" v-on:click="saveGame()">&nbsp; {{ $t('common.save')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required,requiredIf,maxLength,between } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import Multiselect from 'vue-multiselect'
let vm = null

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    cSwitch,
    MaskedInput,
    Multiselect
  },
  data: function () {
    return {
      images: ['desktop', 'mobile'],
      coupons:{},
      couponList:[],
      couponValueList: [
        {
          text: '0', // no win
          value: '0'
        },
        {
          text: 'minor',
          value: '1'
        },
        {
          text: 'major',
          value: '2'
        },
        {
          text: 'mega',
          value: '3'
        }
      ],
      item: {
        game_id: 0,
        uuid: "",
        game_settings:[],
        description:{},
        active:1,
        image: {},
        name: {},
        time_play: this.$auth.user().config.games ? this.$auth.user().config.games.time_play : 5,
        url: ''
      },
      basicInformationStatus: true,
      gameSettingStatus: true,
      imageData: {},
      loadCouponListStatus: false,
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    item: {
      name: {
        required,
        maxLength: maxLength(50)
      }
    }
  },
  methods: {
    isNZ() {
      const clientId = localStorage.getItem('clientID')
      const isNZ = clientId === this.client_uuid.nz
      return isNZ
    },
    couponCodeChange(index, couponCode) {
      if (couponCode.value === 'lose') {
        vm.item.game_settings[index].coupon_value = {
          text: '0', // no win
          value: '0'
        }
      } else {
        vm.item.game_settings[index].coupon_value = ''
      }

    },
    timeForGame (time) {
      switch (time) {
        case 1:
          return this.$t('1st', {time: time})
        case 2:
          return this.$t('2nd', {time: time})
        case 3:
          return this.$t('3rd', {time: time})
        default:
          return this.$t('nth', {time: time})
      }
    },
    generateTextCouponValue(key) {
      switch (key) {
        case '1':
          return this.$t('minor')
        case '2':
          return this.$t('major')
        case '3':
          return this.$t('mega')
        default:
          return key
      }
    },
    getGameCouponList() {
      vm.loadCouponListStatus = true
      let params = 'current_date=' + this.$moment().format('YYYY-MM-DD');
      vm.axios.coupon.getGameCouponList(params, function(response){
        let data=response.data.data.items
        if(!data) return
        let langs = vm.$store.getters.languages
        for (let l in langs) {
          vm.coupons[langs[l]] = []
          for (let c in data) {
            let item = data[c]
            if (item['name'] != null && item['name'][langs[l]] != undefined && item['name'][langs[l]] != '') {
              vm.coupons[langs[l]].push({
                  value: item['code'],
                  text: item['name'][langs[l]]
              })
            }
          }
          // add lose otem
          vm.coupons[langs[l]].push({
              value: 'lose',
              text: vm.isNZ() ? vm.$t('game.no_win') : vm.$t('game.lose', langs[l])
          })
          // add hut reward
          vm.coupons[langs[l]].push({
            value: 'add_slice',
            text: vm.$t('game.add_slice', langs[l])
          })
        }
        vm.$forceUpdate('coupons')
        vm.loadCouponListStatus = false
      })
    },
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    updateGameSettingStatus () {
      this.gameSettingStatus = this.gameSettingStatus?false:true
    },
    initialImage(){
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ""
      }
      vm.imageData = data
    },
    saveGame () {
      let oldUrl = []
      let formData = new FormData()
      for (let i in vm.item.image) {
        if (vm.item.image[i] && vm.item.image[i].type) {
          formData.append(i, vm.item.image[i])
        }
        else{
          oldUrl[i] = vm.item.image[i]
        }
      }
      if(vm.isNZ()) {
        for (let g in vm.item.game_settings) {
          const element = vm.item.game_settings[g].coupon_value.value || vm.item.game_settings[g].coupon_value;
          vm.item.game_settings[g].coupon_value = element
        }
      }
      let config = {headers: {'Content-Type': 'multipart/form-data'}}
      //call an API to save imag
      vm.axios.coupon.uploadGameImages(formData, config, function(response){
        vm.item.image={}
        if(response.data.status===true){
          vm.initialImage()

          for (let i in response.data.data.item) {
            vm.item.image[i] = response.data.data.item[i]
            vm.imageData[i] = response.data.data.item[i]
          }
          //get old url
          for (let i in oldUrl) {
            vm.item.image[i] = oldUrl[i]
            vm.imageData[i] = oldUrl[i]
          }
          // vm.imageData = vm.item.image

          if (vm.id == 'create' || vm.id == undefined) {
            vm.axios.coupon.createGame(vm.item, function(response){
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
              vm.$router.push({name: 'game_list'})
            }, function(){
              vm.isProcessing = false
              vm.convertGameValueForNZ()
            });
          } else {
            vm.axios.coupon.updateGame(vm.item, function(response){
              vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
              vm.isProcessing = false
              vm.convertGameValueForNZ()
            }, function(){
              vm.isProcessing = false
              vm.convertGameValueForNZ()
            });
          }
          
        }
      }, function(error){
      })
    },
    convertGameValueForNZ() {
      if(vm.isNZ()) {
        if(vm.item.game_settings && vm.item.game_settings.length > 0) {
          for (let g = 0; g < vm.item.game_settings.length; g++) {
            let couponValue = vm.item.game_settings[g].coupon_value;
            let value = {
              text: vm.generateTextCouponValue(couponValue),
              value: couponValue
            }
            vm.item.game_settings[g].coupon_value = value
          }
        }
      }
    },
    removeGameSetting (index) {
      let dates = []
      for (let i in this.item.game_settings) {
        if (i != index) {
          dates.push(this.item.game_settings[i])
        }
      }
      this.item.game_settings = dates
    },
    addGameSetting () {
      let time_play = []
      for (let i=0; i < vm.item.time_play; i++) {
        time_play[i] = ''
      }
      this.item.game_settings.push({
        coupon_value: '',
        coupon_code: '',
        time_play: time_play
      })
      // if(vm.isNZ()) {
      //   if(this.item.game_settings.length > 4) {
      //     vm.couponValueList.push({
      //       text: this.item.game_settings.length - 1,
      //       value: this.item.game_settings.length - 1
      //     })
      //   }
      // }
    },
    previewImage (event) {
      let input = event.target
      if (input.files && input.files[0]) {
        let reader = new FileReader()
        reader.onload = (e) => {
          this.imageData[input.id] = e.target.result
        }
        let data = {}
        for (let i in this.images) {
          data[this.images[i]] = this.imageData[this.images[i]]
        }
        this.imageData = data
        reader.readAsDataURL(input.files[0])
        this.item.image[input.id] = input.files[0]
      }
    },
    mappingData(game)
    {
      vm.item.game_id = game.id
      vm.item.name=game.name
      vm.item.description=game.description
      vm.item.image=game.image
      vm.item.active=game.active
      vm.item.game_settings=game.game_settings
      if(vm.isNZ()) {
        if(vm.item.game_settings && vm.item.game_settings.length > 0) {
          for (let g = 0; g < vm.item.game_settings.length; g++) {
            let couponValue = vm.item.game_settings[g].coupon_value;
            let value = {
              text: vm.generateTextCouponValue(couponValue),
              value: couponValue
            }
            vm.item.game_settings[g].coupon_value = value
            // if(vm.item.game_settings.length > 4) {
            //   //if game setting have length > 4, we need add more option to choice
            //   vm.couponValueList.push(value)
            // }
          }
        }
      }
      vm.item.url=game.url

      for (let i in vm.images) {
        vm.imageData[vm.images[i]] = game.image[vm.images[i]] != null ? game.image[vm.images[i]] : ''
      }
    },
    getGameDetail()
    {
      vm.$bus.$emit('loading', 'block')
      //get coupon detail
      vm.axios.coupon.getGameDetail(vm.id, function(response){
        let game=response.data.data.item
        vm.mappingData(game)

        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    }
  },
  created: function () {
    vm = this
    vm.getGameCouponList()
  },
  updated: function () {
    if (vm.coupons[vm.$session.get('lang')]!==undefined) {
      vm.couponList = vm.coupons[vm.$session.get('lang')]
    }
  },
  mounted: function(){
    vm.initialImage()
    if (vm.id != 'create' && vm.id !== undefined) {
      vm.item.uuid = vm.id
      vm.getGameDetail()
    }
  }
}
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }


  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }

  .img-min-height {
    min-height: 0 !important;
  }

  /*.multiselect__tags{
    min-height: 35px !important;
    padding: 2px 15px 0px 10px !important;
  }

  .multiselect__select{
    height: 36px !important;
  }

  .multiselect__placeholder{
    margin-bottom: 5px !important;
    padding-top: 4px !important;
  }*/

  .multiselect__placeholder{
    margin-bottom: 6px !important;
  }
</style>

<style scoped>
  .payment-methods{
    padding: 0 !important;
  }

  .payment-methods .form-group{
    padding: 10px 15px 0 15px;
    margin-bottom: 5px;
  }

  .payment-methods .form-group:last-child{
    margin-bottom: 15px;
  }

  .payment-methods .form-check{
    margin-left: 15px;
  }

  .business-hours .form-check{
    padding-right: 15px;
  }

  .business-hours{
    display: inline-flex;
    vertical-align: middle;
  }

  .size-circle{
    margin-left: 5px;
  }

  .sl-discount-unit,
  .ipt-discount-unit{
    min-height: 40px;
  }

  .delete-csv{
    background: transparent;
    color: #0086FF;
    border: none;
    font-size: 20px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store{
    display: inline-flex;
  }

  /*.applicable-store label{
    margin-right: 20px;
  }*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }
  .gray-background .form-control{
    padding: 8px;
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-properties{
    display: -webkit-inline-box;
    position: relative;
    margin: 0;
    padding: 0;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/views/admin/game/SettingForm.vue